/*
 * FORM BUSINESS DEVELOPMENT
 */

function calculerDifferenceMultiplie(horaire1, horaire2) {
  const [heure1, minute1] = horaire1.split(":").map(Number);
  const [heure2, minute2] = horaire2.split(":").map(Number);

  const date1 = new Date(2000, 0, 1, heure1, minute1);
  const date2 = new Date(2000, 0, 1, heure2, minute2);

  const differenceMs = Math.abs(date2 - date1);
  const differenceHeures = differenceMs / (1000 * 60 * 60);

  // CGV : toute heure entamée est facturée comme une heure pleine
  return Math.ceil(differenceHeures) * 50;
}

document.addEventListener("DOMContentLoaded", function () {
  let links;

  // Each form sets its own booking lead time via data-daybeforebooking, 10 days otherwise
  document.querySelectorAll(".datepicker-business").forEach(function (dateField) {
    const daysBefore = parseInt(dateField.dataset.daybeforebooking, 10);
    flatpickr(dateField, {
      minDate: new Date().fp_incr(isNaN(daysBefore) ? 10 : daysBefore),
      allowInput: true,
      locale: document.querySelector("body").dataset.lang ? document.querySelector("body").dataset.lang : "en",
    });
  });

  flatpickr(".hourpicker-business", {
    enableTime: true,
    allowInput: true,
    noCalendar: true,
    dateFormat: "H:i",
    time_24hr: true,
    minTime: "10:00",
    maxTime: "02:00",
    locale: document.querySelector("body").dataset.lang ? document.querySelector("body").dataset.lang : "en",
    onOpen: function (selectedDates, dateStr, instance) {
      if (dateStr === "") {
        instance.setDate("12:00");
      }
    },
  });

  if (document.querySelectorAll(".js-venue-mission").length > 0) {
    let venueMission = document.querySelector(".js-venue-mission");
    venueMission.addEventListener("change", (e) => {
      e.preventDefault();
      if (venueMission.value === "Other" || venueMission.value === "Autre" || venueMission.value === "Andere") {
        document.querySelector(".js-venue-mission-other").classList.remove("hidden");
      } else {
        document.querySelector(".js-venue-mission-other").classList.add("hidden");
      }
    });
  }

  if (document.querySelectorAll("[data-checklink]").length > 0) {
    let checkLinks = document.querySelectorAll("[data-checklink]");
    for (const checkLink of checkLinks) {
      checkLink.addEventListener("click", (e) => {
        if (checkLink.dataset.checklink.split(",").length > 1) {
          links = checkLink.dataset.checklink.split(",");
        } else {
          links = [checkLink.dataset.checklink];
        }

        if (checkLink.dataset.checklinkinvert) {
          for (const link of links) {
            let checks = document.querySelectorAll(`.field-${link}`);
            for (const check of checks) {
              if ((!check.classList.contains("hidden") && checkLink.checked && check.type == "checkbox") || (document.querySelector(`[name="${checkLink.getAttribute("name")}"]`) && document.querySelector(`[name="${checkLink.getAttribute("name")}"]:checked`))) {
                check.classList.add("hidden");
                check.classList.remove("d-flex");
                if ((check.tagName === "INPUT" && !(check.type == "radio")) || check.tagName == "SELECT") {
                  check.value = "";
                  check.required = false;
                }
              } else {
                check.classList.remove("hidden");
                check.classList.add("d-flex");
                check.required = true;
              }
            }
          }
        } else {
          for (const link of links) {
            let checks = document.querySelectorAll(`.field-${link}`);
            for (const check of checks) {
              if (check.classList.contains("hidden") && checkLink.checked) {
                check.classList.remove("hidden");
                check.classList.add("d-flex");
                if (check.type !== "radio") {
                  check.required = true;
                }
              } else {
                check.classList.add("hidden");
                check.classList.remove("d-flex");
                if ((check.tagName === "INPUT" && !(check.type == "radio")) || check.tagName == "SELECT") {
                  check.value = "";
                  check.required = false;
                }
              }
            }
          }
        }
      });
    }
  }

  let valueOption = 0;
  let currentValueOption = 0;
  let valueWelcomer1 = 0;
  let valueWelcomer2 = 0;
  let numberOfWelcomers = 0;

  if (document.querySelectorAll(".js-calcul-welcomer-1").length > 0) {
    let jsCalculWelcomers1 = document.querySelectorAll(".js-calcul-welcomer-1");
    for (const jsCalculWelcomer1 of jsCalculWelcomers1) {
      jsCalculWelcomer1.addEventListener("change", function (e) {
        var inputsValue = [];
        for (const jsCalculWelcomer1Check of jsCalculWelcomers1) {
          if (jsCalculWelcomer1Check.value) {
            inputsValue++;
          }
        }

        if (inputsValue == jsCalculWelcomers1.length) {
          valueWelcomer1 = calculerDifferenceMultiplie(document.querySelector('[name="starttimewelcome1"]').value, document.querySelector('[name="endtimewelcome1"]').value);
          numberOfWelcomers = valueWelcomer1 != 0 && valueWelcomer2 != 0 ? 2 : (valueWelcomer1 != 0 && valueWelcomer2 == 0) || (valueWelcomer1 == 0 && valueWelcomer2 != 0) ? 1 : 0;
          if (document.querySelectorAll("[name='delayoption']").length > 0) {
            const delayOptions = document.querySelectorAll("[name='delayoption']");
            for (const delayOption of delayOptions) {
              if (delayOption.checked) {
                valueOption = delayOption.getAttribute("id") == "delayoption1" ? 25 * numberOfWelcomers : delayOption.getAttribute("id") == "delayoption2" ? 50 * numberOfWelcomers : 0;
                document.querySelector(".js-total-welcomer").value = parseInt(document.querySelector(".js-total-welcomer").value) - currentValueOption + valueOption;
                currentValueOption = valueOption;
              }
            }
          }

          var calculHours = valueWelcomer1 + valueWelcomer2 + currentValueOption;
          document.querySelector(".js-total-welcomer").value = calculHours;
        } else {
          valueWelcomer1 = 0;
          numberOfWelcomers = valueWelcomer1 != 0 && valueWelcomer2 != 0 ? 2 : (valueWelcomer1 != 0 && valueWelcomer2 == 0) || (valueWelcomer1 == 0 && valueWelcomer2 != 0) ? 1 : 0;
          if (document.querySelectorAll("[name='delayoption']").length > 0) {
            const delayOptions = document.querySelectorAll("[name='delayoption']");
            for (const delayOption of delayOptions) {
              if (delayOption.checked) {
                valueOption = delayOption.getAttribute("id") == "delayoption1" ? 25 * numberOfWelcomers : delayOption.getAttribute("id") == "delayoption2" ? 50 * numberOfWelcomers : 0;
                document.querySelector(".js-total-welcomer").value = parseInt(document.querySelector(".js-total-welcomer").value) - currentValueOption + valueOption;
                currentValueOption = valueOption;
              }
            }
          }

          var calculHours = valueWelcomer1 + valueWelcomer2 + currentValueOption;
          document.querySelector(".js-total-welcomer").value = calculHours;
        }
      });
    }
  }

  if (document.querySelectorAll(".js-calcul-welcomer-2").length > 0) {
    let jsCalculWelcomers2 = document.querySelectorAll(".js-calcul-welcomer-2");
    for (const jsCalculWelcomer2 of jsCalculWelcomers2) {
      jsCalculWelcomer2.addEventListener("change", function (e) {
        var inputsValue = [];
        for (const jsCalculWelcomer2Check of jsCalculWelcomers2) {
          if (jsCalculWelcomer2Check.value) {
            inputsValue++;
          }
        }

        if (inputsValue == jsCalculWelcomers2.length) {
          valueWelcomer2 = calculerDifferenceMultiplie(document.querySelector('[name="starttimewelcome2"]').value, document.querySelector('[name="endtimewelcome2"]').value);
          numberOfWelcomers = valueWelcomer1 != 0 && valueWelcomer2 != 0 ? 2 : (valueWelcomer1 != 0 && valueWelcomer2 == 0) || (valueWelcomer1 == 0 && valueWelcomer2 != 0) ? 1 : 0;
          if (document.querySelectorAll("[name='delayoption']").length > 0) {
            const delayOptions = document.querySelectorAll("[name='delayoption']");
            for (const delayOption of delayOptions) {
              if (delayOption.checked) {
                valueOption = delayOption.getAttribute("id") == "delayoption1" ? 25 * numberOfWelcomers : delayOption.getAttribute("id") == "delayoption2" ? 50 * numberOfWelcomers : 0;
                document.querySelector(".js-total-welcomer").value = parseInt(document.querySelector(".js-total-welcomer").value) - currentValueOption + valueOption;
                currentValueOption = valueOption;
              }
            }
          }

          var calculHours = valueWelcomer2 + valueWelcomer1 + currentValueOption;
          document.querySelector(".js-total-welcomer").value = calculHours;
        } else {
          valueWelcomer2 = 0;
          numberOfWelcomers = valueWelcomer1 != 0 && valueWelcomer2 != 0 ? 2 : (valueWelcomer1 != 0 && valueWelcomer2 == 0) || (valueWelcomer1 == 0 && valueWelcomer2 != 0) ? 1 : 0;
          if (document.querySelectorAll("[name='delayoption']").length > 0) {
            const delayOptions = document.querySelectorAll("[name='delayoption']");
            for (const delayOption of delayOptions) {
              if (delayOption.checked) {
                valueOption = delayOption.getAttribute("id") == "delayoption1" ? 25 * numberOfWelcomers : delayOption.getAttribute("id") == "delayoption2" ? 50 * numberOfWelcomers : 0;
                document.querySelector(".js-total-welcomer").value = parseInt(document.querySelector(".js-total-welcomer").value) - currentValueOption + valueOption;
                currentValueOption = valueOption;
              }
            }
          }

          var calculHours = valueWelcomer2 + valueWelcomer1 + currentValueOption;
          document.querySelector(".js-total-welcomer").value = calculHours;
        }
      });
    }
  }

  if (document.querySelectorAll("[name='delayoption']").length > 0) {
    const delayOptions = document.querySelectorAll("[name='delayoption']");
    for (const delayOption of delayOptions) {
      delayOption.addEventListener("click", function (e) {
        numberOfWelcomers = valueWelcomer1 != 0 && valueWelcomer2 != 0 ? 2 : (valueWelcomer1 != 0 && valueWelcomer2 == 0) || (valueWelcomer1 == 0 && valueWelcomer2 != 0) ? 1 : 0;
        if (delayOption.checked) {
          valueOption = delayOption.getAttribute("id") == "delayoption1" ? 25 * numberOfWelcomers : delayOption.getAttribute("id") == "delayoption2" ? 50 * numberOfWelcomers : 0;
          document.querySelector(".js-total-welcomer").value = parseInt(document.querySelector(".js-total-welcomer").value) - currentValueOption + valueOption;
          currentValueOption = valueOption;
        } else {
          document.querySelector(".js-total-welcomer").value = parseInt(document.querySelector(".js-total-welcomer").value) - valueOption;
          currentValueOption = 0;
        }
      });
    }
  }

  if (document.querySelectorAll('[name="securedelay"]').length > 0) {
    let inputSecureDelay = document.querySelector('[name="securedelay"]');
    inputSecureDelay.addEventListener("change", function (e) {
      if (inputSecureDelay.checked) {
        document.querySelector(".js-total-welcomer").value = parseInt(document.querySelector(".js-total-welcomer").value) + currentValueOption;
      } else {
        document.querySelector(".js-total-welcomer").value = parseInt(document.querySelector(".js-total-welcomer").value) - currentValueOption;
      }
    });
  }

  // Generic required-field validation, shared by every form tagged .js-form-validate
  document.querySelectorAll(".js-form-validate").forEach(function (formBusiness) {
    const brochuresError = formBusiness.querySelector(".js-brochures-error");
    const INVALID_COLOR = "var(--color-red-lcto)";

    const isVisible = (el) => el.offsetParent !== null;

    const isFieldValid = (el) => {
      if (el.type === "checkbox") return el.checked;
      if (el.type === "radio") {
        return !!formBusiness.querySelector(`[name="${el.name}"]:checked`);
      }
      return el.value && el.value.trim() !== "";
    };

    const markInvalid = (el) => {
      el.style.setProperty("border-color", INVALID_COLOR, "important");
      if (el.type === "radio") {
        el.style.setProperty("box-shadow", "0px 0px 4px red", "important");
      }
    };

    const clearInvalid = (el) => {
      el.style.removeProperty("border-color");
      el.style.removeProperty("box-shadow");
    };

    const validateRequiredFields = () => {
      const requiredFields = formBusiness.querySelectorAll("[required]");
      let firstInvalid = null;
      const seenRadioGroups = new Set();
      for (const f of requiredFields) {
        if (!isVisible(f)) {
          clearInvalid(f);
          continue;
        }
        if (f.type === "radio") {
          if (seenRadioGroups.has(f.name)) continue;
          seenRadioGroups.add(f.name);
        }
        if (isFieldValid(f)) {
          clearInvalid(f);
        } else {
          markInvalid(f);
          if (!firstInvalid) firstInvalid = f;
        }
      }
      return firstInvalid;
    };

    const hasAtLeastOneBrochure = () => {
      const quantities = formBusiness.querySelectorAll(".number-brochure");
      for (const q of quantities) {
        if (parseInt(q.value, 10) >= 1) return true;
      }
      return false;
    };

    formBusiness.querySelectorAll("[required]").forEach((f) => {
      const evt = f.tagName === "SELECT" || f.type === "checkbox" || f.type === "radio" ? "change" : "input";
      f.addEventListener(evt, () => {
        if (isFieldValid(f)) {
          clearInvalid(f);
          if (f.type === "radio") {
            formBusiness.querySelectorAll(`[name="${f.name}"]`).forEach(clearInvalid);
          }
        }
      });
    });

    formBusiness.querySelectorAll(".number-brochure").forEach((q) => {
      q.addEventListener("input", () => {
        if (brochuresError && hasAtLeastOneBrochure()) {
          brochuresError.classList.add("hidden");
        }
      });
    });

    formBusiness.addEventListener("submit", function (e) {
      const firstInvalid = validateRequiredFields();
      const needBrochure = formBusiness.querySelector("#needbrochure");
      const brochureMissing = needBrochure && needBrochure.checked && !hasAtLeastOneBrochure();

      if (brochuresError) {
        brochuresError.classList.toggle("hidden", !brochureMissing);
      }

      if (firstInvalid || brochureMissing) {
        e.preventDefault();
        e.stopPropagation();
        const scrollTarget = firstInvalid || brochuresError;
        if (scrollTarget) {
          scrollTarget.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
    });
  });
});

// Example starter JavaScript for disabling form submissions if there are invalid fields
// (function () {
//   "use strict";

//   // Fetch all the forms we want to apply custom Bootstrap validation styles to
//   var forms = document.querySelectorAll(".needs-validation");

//   // Loop over them and prevent submission
//   Array.prototype.slice.call(forms).forEach(function (form) {
//     form.addEventListener(
//       "submit",
//       function (event) {
//         if (!form.checkValidity()) {
//           event.preventDefault();
//           event.stopPropagation();
//         }

//         form.classList.add("was-validated");
//       },
//       false
//     );
//   });
// })();
